<template>
  <modal
    :show.sync="modalSync"
    bodyClasses="padding-body px-2 px-md-5"
    headerClasses="bg-success"
    cardClasses="modal-card-width"
    modalClasses="modal-width mt-0"
    @close="close"
  >
    <!-- FILTER DESKTOP -->
    <form @submit.prevent="updateFilters" class="d-md-block d-none">
      <label
        for=""
        class="text-muted mr-md-2 col-md-auto d-md-block pl-0 d-none"
      >
        Rango de fechas
        <i
          @click="resetFilters"
          class="fa fa-refresh text-success pointer"
          aria-hidden="true"
        ></i>
      </label>
      <el-date-picker
        type="daterange"
        v-model="dateRangeLogsFilter"
        range-separator=":"
        start-placeholder="Desde"
        end-placeholder="Hasta"
        class="d-none d-md-inline-flex"
        size="small"
        format="dd-MM-yyyy"
      />
      <button
        class="btn btn-primary btn-sm rounded-pill pull-right"
        type="submit"
      >
        Filtrar
      </button>
    </form>
    <!-- FILTER MOBILE -->
    <div
      class="d-md-none col-12 d-flex flex-row"
      :class="showMobileFilters ? 'position-absolute' : ''"
    >
      <el-tooltip :open-delay="200" placement="top">
        <template #content> Filtrar Registros </template>
        <i
          class="fa pointer ml-auto mr-0 mb-0"
          :class="
            showMobileFilters
              ? 'text-success fa-1x fa-refresh custom-index'
              : 'text-info fa-filter fa-2x'
          "
          aria-hidden="true"
          @click="showMobileFilters = !showMobileFilters"
        ></i>
      </el-tooltip>
    </div>
    <form
      @submit.prevent="updateFilters"
      class="d-md-none d-flex flex-row"
      v-if="showMobileFilters"
    >
      <div class="col-8">
        <label for="" class="text-muted small mb-0">Desde</label>
        <el-date-picker
          v-model="dateRangeLogsFilter[0]"
          class="d-md-none"
          size="small"
          format="dd-MM-yyyy"
        />
        <label for="" class="text-muted small mb-0">Hasta</label>
        <el-date-picker
          v-model="dateRangeLogsFilter[1]"
          class="d-md-none"
          size="small"
          format="dd-MM-yyyy"
        />
      </div>
      <div class="col d-flex flex-column">
        <button
          class="btn btn-primary btn-sm rounded-pill m-auto"
          type="submit"
        >
          Filtrar
        </button>
      </div>
    </form>
    <hr :class="showMobileFilters ? '' : 'mt-2 mt-md-4'" />
    <template slot="header">
      <h3 class="font-weight-bold text-light mb-0">
        <i class="nc-icon nc-book-bookmark" aria-hidden="true"></i>
        Historial de modificaciones
      </h3>
    </template>

    <!-- DESKTOP TABLE -->
    <div ref="scrollContainerDesktop">
      <el-table
        :data="logData"
        height="500"
        header-row-class-name="bg-warning"
        @scroll="handleScroll"
        class="d-none d-md-block"
      >
        <el-table-column
          prop="fechaIngresoHistorial"
          label="Fecha"
          width="120"
          @scroll="handleScroll"
        >
        </el-table-column>
        <el-table-column prop="detalleHistorial" label="acción">
        </el-table-column>
        <el-table-column prop="descripcionPlan" label="Membresia" width="200">
        </el-table-column>
        <el-table-column
          prop="responsableModificacion"
          label="responsable"
          width="200"
        >
        </el-table-column>
        <el-table-column label="Detalle" width="100">
          <template #default="scope">
            <p-button
              class="ml-3"
              type="info"
              outline
              icon
              round
              @click="showDetails(scope.row)"
              ><i class="nc-icon nc-zoom-split"></i></p-button
          ></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- MOBILE TABLE -->
    <div ref="scrollContainerMobile">
      <el-table
        :data="logData"
        height="500"
        header-row-class-name="bg-warning"
        @scroll="handleScroll"
        class="d-md-none"
        size="small"
      >
        <el-table-column
          prop="fechaIngresoHistorial"
          label="Fecha"
          width="100"
          @scroll="handleScroll"
        >
        </el-table-column>
        <el-table-column
          prop="detalleHistorial"
          width="190"
          class=""
          label="acción"
        >
        </el-table-column>
        <el-table-column label="Más">
          <template #default="scope">
            <p-button
              class=""
              type="info"
              outline
              icon
              round
              @click="showDetails(scope.row)"
              ><i class="nc-icon nc-zoom-split"></i></p-button
          ></template>
        </el-table-column>
      </el-table>
    </div>
  </modal>
</template>

<script>
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
export default {
  name: "CustomerMembershipLog",
  props: {
    logData: {
      type: Array,
      default: () => [
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial:
            "Un detalle soberbio Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
        {
          fechaIngresoHistorial: "01-01-1900",
          detalleHistorial: "Un detalle soberbio Un detalle soberbio",
        },
      ],
    },
    modalSync: {
      type: Boolean,
      default: false, //Cambiar a false
    },
  },
  watch: {
    showMobileFilters: function (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.dateRangeLogsFilter = ["", ""];
        this.updateFilters();
      }
    },
    "dateRangeLogsFilter.0": function (newValue, oldValue) {
      // console.log("ha cambiado");
      if (newValue) {
        if (this.dateRangeLogsFilter[1]) {
          if (newValue > this.dateRangeLogsFilter[1]) {
            this.dateRangeLogsFilter[0] = this.dateRangeLogsFilter[1];
          }
        }
      }
    },
    "dateRangeLogsFilter.1": function (newValue, oldValue) {
      // console.log("ha cambiadossss");
      if (newValue) {
        if (this.dateRangeLogsFilter[0]) {
          if (newValue < this.dateRangeLogsFilter[0]) {
            this.dateRangeLogsFilter[1] = this.dateRangeLogsFilter[0];
          }
        }
      }
    },
  },
  data() {
    return {
      dateRangeLogsFilter: ["", ""],
      showMobileFilters: false,
      setDateValues: true,
    };
  },
  components: {
    Badge,
    CollapseItem,
    Collapse,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  methods: {
    test() {
      console.log(this.$refs.scrollContainerDesktop);
      console.log(this.$refs.scrollContainerMobile);
    },
    resetFilters() {
      this.dateRangeLogsFilter = ["", ""];
      this.updateFilters();
    },
    updateFilters() {
      this.$emit("dateRangeLogsFilter", this.dateRangeLogsFilter);
    },
    handleScroll(event) {
      // console.log('eventeando')
      const { target } = event;
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        // console.log("Alcanzado el final del scroll, carga más datos.");
        this.$emit("fetchLogs");
        // Aquí puedes llamar a una función para cargar más datos
      }
    },
    showDetails(data) {
      const id = data._id;
      this.$emit("showLogDetails", id);
    },
    close() {
      this.showMobileFilters = false;
      this.dateRangeLogsFilter = ["", ""]
      this.$emit("close");
    },
    dsadsadsa() {
      return "bg-warning";
    },
  },
  mounted() {
    // Espera a que el DOM esté actualizado
    this.$nextTick(() => {
      const tableBodyWrapper_Desktop =
        this.$refs.scrollContainerDesktop.querySelector(
          ".el-table__body-wrapper"
        );
      if (tableBodyWrapper_Desktop) {
        tableBodyWrapper_Desktop.addEventListener("scroll", this.handleScroll);
      }
      const tableBodyWrapper_Mobile =
        this.$refs.scrollContainerMobile.querySelector(
          ".el-table__body-wrapper"
        );
      if (tableBodyWrapper_Mobile) {
        tableBodyWrapper_Mobile.addEventListener("scroll", this.handleScroll);
      }
    });
  },
  beforeDestroy() {
    // Limpieza: asegúrate de remover el listener de eventos cuando el componente se destruya
    const tableBodyWrapper_Desktop =
      this.$refs.scrollContainerDesktop.querySelector(
        ".el-table__body-wrapper"
      );
    if (tableBodyWrapper_Desktop) {
      tableBodyWrapper_Desktop.removeEventListener("scroll", this.handleScroll);
    }
    const tableBodyWrapper_Mobile =
      this.$refs.scrollContainerMobile.querySelector(".el-table__body-wrapper");
    if (tableBodyWrapper_Mobile) {
      tableBodyWrapper_Mobile.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style>
.modal-table {
  max-height: 200px;
  overflow: hidden;
}
.modal-width {
  margin-left: 12vw;
}
.modal-card-width {
  width: 80vw;
}
@media (max-width: 1250px) {
  .modal-card-width {
    width: 95vw;
  }
  .modal-width {
    margin-left: 3vw;
  }
  .padding-body {
    padding: auto, 0px;
  }
  .modal-table {
    max-height: 600px;
    overflow: hidden;
  }
  .custom-index {
    z-index: 1500;
  }
}
</style>
